import { useState } from "react";

export const ProductDetailsPublish2 = () => {
    const [tab, setTab] = useState("tab-1");
    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">제품 상세보기</h3>
                    <div className="filter_toolbar">
                        <div className="frm_row search justify-content-start">
                            <label for="" className="form-label frm_label">CRM 연동</label>
                            <select className="form-select w-150px me-0">
                                <option>사용</option>
                            </select>
                            <button className="btn btn-info btn_search">저장</button>
                        </div>
                    </div>
                </div>

                <h5 className="subheading">제품 정보</h5>
                <table className="table table-bordered my_table table_detail m-0">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>품목명</th>
                            <td colSpan={3}>S1-WIN Pro-E7 SP1 32-64b</td>
                        </tr>
                        <tr>
                            <th>생성일자</th>
                            <td style={{ width: "31.3%" }}>2024.05.05</td>
                            <th style={{ width: "16.66%" }}>생성자</th>
                            <td>SYSTEM</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="mybtns_group">
                <div className="btn-group" role="group" aria-label="">
                    <button type="button" className={tab == "tab-1" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-1")}>품목정보</button>
                    <button type="button" className={tab == "tab-2" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-2")}>가격정보</button>
                </div>
                <div className="mybtns_group_toolbar">
                    <button className="btn btn-outline-primary w-100px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt="" />목록</button>
                </div>
            </div>

            <div className="content_wrap">
                <h5 className="subheading">품목 제품 상세보기</h5>
                <div className="detail_outer_2">
                    <div className="left">
                        <table className="table table-bordered my_table table_detail m-0">
                            <tbody>
                                <tr className="h-329px">
                                    <th style={{ width: "33.6%", verticalAlign: "middle" }}>제품 사진</th>
                                    <td>
                                        <div className="div_uploader">
                                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_file.png"} alt="" />
                                            <div>
                                                첨부할 파일을 끌어다 놓거나
                                                <br />
                                                <span>찾아보기</span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="right">
                        <table className="table table-bordered my_table table_detail m-0">
                            <tbody>
                                <tr>
                                    <th style={{ width: "33.6%" }}>품목명</th>
                                    <td>S1-WIN Pro-E7 SP1 32-64b</td>
                                </tr>
                                <tr>
                                    <th>벤더</th>
                                    <td>MS</td>
                                </tr>
                                <tr>
                                    <th>카테고리</th>
                                    <td>Compact</td>
                                </tr>
                                <tr>
                                    <th>규격</th>
                                    <td>42C-00039</td>
                                </tr>
                                <tr>
                                    <th>품목코드</th>
                                    <td>00000000000</td>
                                </tr>
                                <tr>
                                    <th>대분류</th>
                                    <td>OS</td>
                                </tr>
                                <tr>
                                    <th>중분류</th>
                                    <td>Win7</td>
                                </tr>
                                <tr>
                                    <th>사업부별 제품군</th>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>


        </>
    );
}